import * as z from "zod";
import {
  ProcessingReceivingSource,
  ProcessingReceivingTarget,
} from "./processing-receiving-source";

export const getProcessingReceivingSource = {
  name: "getProcessingReceivingSource" as const,
  input: z.object({ target: ProcessingReceivingTarget }),
  output: ProcessingReceivingSource,
};
